import React from "react";
import "./App.css";
import AppRoutes from "./routes";
import "./styles/main.scss";
import { ToastProvider } from "components/Toast";
import BrandingProvider from "components/BrandingProvider";

const App = () => {
    return (
        <BrandingProvider>
            <ToastProvider>
                <AppRoutes />
            </ToastProvider>
        </BrandingProvider>
    );
};

export default App;
